import React from 'react'
import { Card, Typography } from 'antd'

const { Text } = Typography

const DiagnosisOverview = ({ ...props }) => {
  return (
    <Card size='small'>
      <Text type='secondary'>Diagnosis History feature has been temporarily disabled.</Text>
    </Card>
  )
}

export default DiagnosisOverview
